const login = {
    errorMessage: '',
    loginModelId: 'login_popup',
    loginForm: $('#login_form'),
    ssoLoginUrl: '/sso/login?successUrl={successUrl}&failureUrl={failureUrl}',
    userNameCookieName: 'nettix-username',
    userPasswordCookieName: 'nettix-password',
    userGroupCookieName: 'nettix-user-groups',
    userGroupCookieValue: 'company',
    cookiePath: '/',
    cookieTime: 0.2, // 12 second
    errorMessageData: {
        '#wrongPasswordLogin': Translations.login_modal.wrong_password_login,
        '#multipleEmailLogin': Translations.login_modal.multiple_email_login,
        '#terminatedUserLogin': Translations.login_modal.terminate_user,
        '#pendingUserLogin': Translations.login_modal.pending_user,
        '#dealerForceUpdate': Translations.login_modal.dealerForceUpdate,
    },
    init() {
        if (location.hash) {
            this.errorMessage = this.errorMessageData[location.hash];
        }

        if (this.errorMessage) {
            this.handleWrongLoginEvents(this.errorMessage);
        }

        $(document).on('click', '.hideShowPassText', function() {
            login.hideShowPasswordText();
        });

        $(document).on('click', '.submitloginButton', function(e) {
            e.preventDefault();
            login.submitFormEvent();
        });
    },
    submitFormEvent() {
        let userId = this.loginForm.find('.login-field').val();
        let password = this.loginForm.find('.password-field').val();
        if (userId === '' || password === '') {
            this.errorMessage = Translations.login_modal.password_login_empty;
            this.loginForm.find('.global-validation-msg').text(this.errorMessage).show();
            window.$.colorbox.resize();
        } else {
            commonUtils.setCookie(this.userNameCookieName, userId, this.cookieTime);
            commonUtils.setCookie(this.userPasswordCookieName, password, this.cookieTime);
            commonUtils.setCookie(this.userGroupCookieName, this.userGroupCookieValue, this.cookieTime);

            let redirectUrl = encodeURIComponent(window.location.href);
            this.ssoLoginUrl = this.ssoLoginUrl.replace('{successUrl}', redirectUrl);
            this.ssoLoginUrl = this.ssoLoginUrl.replace('{failureUrl}', redirectUrl);
            window.location.href = this.ssoLoginUrl;
        }

        return false;
    },
    handleWrongLoginEvents(errorMessge) {
        this.loginForm.find('.global-validation-msg').html(errorMessge).show();

        window.$.colorbox({
            href: `#${login.loginModelId}`, inline: true,
            onClosed() {
                login.loginForm.find('.global-validation-msg').text('').hide();
                window.location.href = Routing.generate('/');
            },
        });

        window.$.colorbox.resize();
        history.pushState('', document.title, window.location.pathname);

    },
    hideShowPasswordText() {
        let password = this.loginForm.find('.hideShowPassField');
        let hideShowPassText = this.loginForm.find('.hideShowPassText');
        if (password.val()) {
            if (password.attr('type') === 'password') {
                password.attr('type', 'text');
                hideShowPassText.text(hideShowPassText.data('hide'));
                hideShowPassText.addClass('hide_cap');
            } else {
                password.attr('type', 'password');
                hideShowPassText.text(hideShowPassText.data('show'));
                hideShowPassText.removeClass('hide_cap');
            }
        } else {
            password.attr('type', 'password');
        }
    },
};

$(function() {
    login.init();

    if (commonUtils.getCookie('alma-login-error')) {
        commonUtils.deleteCookie('alma-login-error');
    }
});
